import { lazy, Suspense, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useNavigate,Navigate } from 'react-router-dom';

import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';

import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

// Lazy loaded pages
const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./jsx/pages/ResetPassword'));
const Login = lazy(() => import('./jsx/pages/Login'));
const Index = lazy(() => import('./jsx')); // your full dashboard

function App({ isAuthenticated }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // The password-reset pages are for someone who cannot sign in. The check
    // below sends anyone without a session to /login, which made both of them
    // unreachable -- so it is skipped there for a signed-out visitor.
    const onResetPage = /^\/(page-forgot-password|reset-password\/)/.test(window.location.pathname);
    if (onResetPage && !localStorage.getItem('user')) return;
    checkAutoLogin(dispatch, navigate);
  }, [dispatch, navigate]);

  return (
    <Suspense fallback={
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    }>
      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/page-register" element={isAuthenticated ? <Navigate to="/dashboard" /> : <SignUp />} />
        <Route path="/page-forgot-password" element={isAuthenticated ? <Navigate to="/dashboard" /> : <ForgotPassword />} />
        {/* The link in the "Forgot password" email. Open to anyone holding it, signed in or not. */}
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/*" element={isAuthenticated ? <Index /> : <Login />} />
      </Routes>
    </Suspense>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(App);
